import type { ReactNode } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import {SiteSettingsProvider} from "@/components/feature/SiteSettingsProvider";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";
import MaintenanceScreen from "@/components/feature/MaintenanceScreen";
import SessionManager from "@/components/feature/SessionManager";
import PublicSeo from "@/components/feature/PublicSeo";

function MaintenanceGate({ children }: { children: ReactNode }) {
  const { settings } = useSiteSettingsContext();
  const { pathname } = useLocation();

  // Yönetici paneli bakım modundan muaf tutulur (yoksa admin bakımı kapatamaz).
  const isAdminArea = pathname.startsWith("/yonetici");

  if (settings.maintenanceMode && !isAdminArea) {
    return (
      <MaintenanceScreen
        siteName={settings.siteName || "DersDinle"}
        message={settings.maintenanceMessage}
      />
    );
  }

  return <>{children}</>;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SiteSettingsProvider>
          <MaintenanceGate>
            <SessionManager />
            <AppRoutes />
            <PublicSeo />
          </MaintenanceGate>
        </SiteSettingsProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
